// extracted by mini-css-extract-plugin
export var emailBlockLink = "_n9-0";